module.exports = __webpack_public_path__ + "static/img/ZJ.eac3a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ZJ.png
// module id = PZb+
// module chunks = 1